import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Breadcrumb component
 *
 * Usage:
 *   <Breadcrumb items={[
 *     { label: 'Home', to: '/' },
 *     { label: 'Schede Pep', to: '/pep-schede' },
 *     { label: 'Royal Oak' },          // last item = current page (no `to`)
 *   ]} />
 */
export default function Breadcrumb({ items = [] }) {
  const navigate = useNavigate();

  return (
    <nav aria-label="breadcrumb" style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
      <ol style={{
        display: 'flex', alignItems: 'center', gap: 2,
        listStyle: 'none', margin: 0, padding: 0,
        flexWrap: 'wrap',
      }}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {i > 0 && (
                <ChevronRight
                  size={12}
                  style={{ color: 'var(--text-dim)', flexShrink: 0, margin: '0 1px' }}
                />
              )}
              {isLast ? (
                <span style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: 'var(--text)',
                }}>
                  {item.label}
                </span>
              ) : (
                <button
                  onClick={() => item.onClick ? item.onClick() : navigate(item.to)}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '2px 4px',
                    borderRadius: 4,
                    fontSize: 13,
                    fontWeight: 400,
                    color: 'var(--text-muted)',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    transition: 'color 0.15s',
                    lineHeight: 'inherit',
                    minHeight: 'unset',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
                  onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}
                >
                  {item.label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
